<template>
    <div v-if="store.org?.features?.headsetFinancing" class="bg-white rounded-lg px-3 py-4 flex items-start relative">
        <input type="checkbox" name="meta_quest_financing" id="meta_quest_financing" class="h-5 w-5 border-2 rounded" v-model="cart.$state.headsetFinancing.enabled">
        <div class="ml-3 w-full">
            <label for="meta_quest_financing" class="space-y-3">
                <div class="flex justify-between">
                    <div>Meta Quest 2</div>
                    <div class="font-normal text-right"><template v-if="cart.$state.headsetFinancing.paymentOption == 'in-full'">$299.99</template><template v-else><template v-if="store.org.features.headsetFinancing.upfrontPayment">{{ formatCurrency(store.org.features.headsetFinancing.upfrontPayment) }} plus
                        <br></template>{{ formatCurrency(store.org.features.headsetFinancing.monthlyPayment) }}/mo</template></div>
                </div>
                <p class="text-sm font-base" v-if="!cart.$state.headsetFinancing.enabled">Having your own VR Headset is recommended for the program. If you do not already own a Meta Quest 2, 3, or Pro, check the box above to add a headset to your order.</p>
            </label>
            <div v-if="cart.$state.headsetFinancing.enabled" class="my-4">
                <ToggleInput name="interval" label="Billing Interval" :options="[{
                    label: 'Pay In Full',
                    value: 'in-full',
                }, {
                    label: 'Pay Over Time',
                    value: 'over-time',
                }]" v-model="cart.$state.headsetFinancing.paymentOption" />
            </div>
            <div class="text-sm text-[#6E7086] space-y-4">
                <p v-if="cart.$state.headsetFinancing.enabled">Fulfilled from Amazon Renewed Store</p>
                <p v-if="cart.$state.headsetFinancing.paymentOption == 'over-time'"><template v-if="store.org.features.headsetFinancing.upfrontPayment">An initial payment of {{ formatCurrency(store.org.features.headsetFinancing.upfrontPayment) }} will be charged for the first month. </template>{{ formatCurrency(store.org.features.headsetFinancing.monthlyPayment) }} will be billed each month for {{ store.org.features.headsetFinancing.numberOfMonths }} months<template v-if="store.org.features.headsetFinancing.upfrontPayment"> ({{ store.org.features.headsetFinancing.numberOfMonths + 1 }} total payments)</template>. Your monthly headset and membership payments will show up as two separate charges on your credit card.</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useCheckoutStore } from '@/store/checkout'
import { useCartStore } from '@/store/cart'
import ToggleInput from '../Form/ToggleInput.vue'
import { formatCurrency } from '@/utils/currency'

const store = useCheckoutStore()
const cart = useCartStore()
</script>
